import { createReducer, on } from '@ngrx/store';
import * as fromAccountActions from '../actions/account.action';
export const featureKey = 'account';

export interface State {
    studentApplication: any
    preEnrollmentRequirements: {
        data: Array<any>,
        isLoaded: Boolean
    };
    academicRequirements: {
        data: Array<any>,
        isLoaded: Boolean
    };
    userProfile: any;
    latestEnrollmentStatus: any;
    curriculumCompletion: {
        data: Array<any>,
        isLoaded: Boolean
    };
}

export const initialState: State = {
    studentApplication: null,
    preEnrollmentRequirements: {
        data: [],
        isLoaded: false
    },
    academicRequirements: {
        data: [],
        isLoaded: false
    },
    userProfile: null,
    latestEnrollmentStatus: null,
    curriculumCompletion: {
        data: [],
        isLoaded: false
    },
}

export const reducer = createReducer(
    initialState,
    on(fromAccountActions.getUserProfileSuccess, (state: State, props: any) => ({
        ...state,
        userProfile: props.data
    })),
    on(fromAccountActions.getStudentApplicationSuccess, (state: State, props: any) => ({
        ...state,
        studentApplication: props.data
    })),
    on(fromAccountActions.getStudentApplicationSuccess, (state: State, props: any) => ({
        ...state,
        studentApplication: props.data
    })),
    on(fromAccountActions.getPreEnrollmentRequirementsSuccess, (state: State, props: any) => ({
        ...state,
        preEnrollmentRequirements: { data: props.data, isLoaded: true },
    })),
    on(fromAccountActions.getAcademicRequirementsSuccess, (state: State, props: any) => ({
        ...state,
        academicRequirements: { data: props.data, isLoaded: true },
    })),
    on(fromAccountActions.getCurriculumCompletionSuccess, (state: State, props: any) => ({
        ...state,
        curriculumCompletion: { data: props.data, isLoaded: true },
    })),
    on(fromAccountActions.getLatestEnrollmentStatusSuccess, (state: State, props: any) => ({
        ...state,
        latestEnrollmentStatus: props.data
    })),
    // on(fromAuthActions.autoLogout, (state: State, props) => initialState),
);